/**
 * 5.1.4 과다 허용 정책 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

export const state = () => ({
  // api url 목록
  apiUrl: {
    // API
    mngConfigUrl: '/api/pm/mng-config'
  },

  // 공통설정 data
  policyMngConfig: {
    '1': { val: '', yn: '' },
    '2': { val: '', yn: '' },
    '3': { val: '', yn: '' },
    '4': { val: '', yn: '' },
    '5': { val: '', yn: '' },
    '6': { val: '', yn: '' }
  },
  overAllowPolicy: null,
  errorMessage: null
})

export const mutations = {
  // 과다 허용 정책 설정 조회
  mutOverAllowPolicy (state, payload) {
    payload.forEach(item => {
      state.policyMngConfig['' + item.policy_mng_config_type] = {val: item.policy_mng_config_value, yn: item.policy_mng_config_use_yn}
    })
  },
  // 과다 허용 정책 설정 수정
  mutPutOverAllowPolicy (state, payload) {
    state.overAllowPolicy = payload
  },
  mutErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  // 과다 허용 정책 설정 조회
  async acsOverAllowPolicy ({commit, state}, param) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.mngConfigUrl}/0`, param)
      // commit('mutPayConfig', res)
      if (res.code === 'ok') {
        commit('mutOverAllowPolicy', res.result)
      } else {
        commit('mutErrorMessage', res.result)
      }
    } catch (error) {
      commit('mutErrorMessage', error)
    }
  },
  // 과다 허용 정책 설정 수정
  async acsPutOverAllowPolicy ({commit, state}, payload) {
    try {
      const res = await this.$axios.$post(`${state.apiUrl.mngConfigUrl}`, payload, {loading: false, successAlert: false})
      if (res.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: res.result.msg}
      }
      commit('mutPutOverAllowPolicy', res)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  acsSetErrorMessage ({commit, state}, payload) {
    const result = {}
    result.error = payload
    commit('mutErrorMessage', result)
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true, loading: false}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.apiUrl.mngConfigUrl}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return error
    }
  }
}
export const getters = {}
export const strict = false
